<template>
    <div class="result-card">
        <div class="card-title">
            <span>{{ title }}</span>
            <slot name="tail"></slot>
        </div>

        <div class="card-content">
            <div class="content-item" v-for="(item, key) in result" :key="key">
                <div class="label">{{ labelMap[key] }}：</div>
                <div class="text">{{ item }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        labelMap: {
            type: Object,
            default: () => ({})
        },
        result: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.result-card {
    margin-top: 16px;
    background: #fbfcff;
    .card-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        line-height: 40px;
        padding: 10px 16px;
        border-bottom: 1px solid #e2e2e2;

        > span {
            font-size: 14px;
            color: #333333;
            font-weight: 600;
        }

        > a {
            font-size: 14px;
            color: #333333;
        }
    }

    .card-content {
        margin-top: 16px;
        .content-item {
            display: inline-block;
            width: 50%;
            font-size: 14px;
            color: #333333;
            line-height: 32px;
            margin-bottom: 16px;

            .label {
                width: 150px;
                text-align: right;
            }

            > div {
                display: inline-block;
            }
        }
    }
}
</style>
